import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { Activity } from "PFCore/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ManageTagsModal } from "./manage_tags_modal";
import { useManageTagsPermissions } from "./use_manage_tags_permissions";

type ManageTagsButtonProps = {
  activity: Activity;
};

export const ManageTagsButton = ({ activity }: ManageTagsButtonProps) => {
  const { t } = useTranslation("activities");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { canReadWriteTags } = useManageTagsPermissions({
    isCoowned: activity.coowned,
    profile: activity.profile,
    templateId: activity.template_id
  });

  if (!canReadWriteTags) {
    return null;
  }

  return (
    <>
      <Tooltip content={t("show.tags.tooltip")}>
        <Button icon="tag" kind="secondary" onClick={() => setIsModalOpen(true)} />
      </Tooltip>
      {isModalOpen && (
        <ManageTagsModal
          activityId={activity.id}
          templateId={activity.template_id}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};
